import { Popover, Space, theme } from 'antd'
import { ExclamationCircleFilled, InfoCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useTaxOffice } from '../lib/useTaxOffice'

export function TaxOfficeDetails({ county, taxId, override }) {
  const { t } = useTranslation()

  const { taxOfficeNumber, taxOffice } = useTaxOffice({
    county,
    taxId,
    override,
  })

  const { token } = theme.useToken()

  if (!taxOffice) {
    return (
      <Space
        size="small"
        align="start"
        style={{
          fontSize: token.fontSizeSM,
          fontWeight: 500,
          color: token.colorWarning,
        }}
      >
        <ExclamationCircleFilled />
        <span>{t('frontend:common.taxOfficeNotDetermined')}</span>
      </Space>
    )
  }

  return (
    <span>
      <Popover
        placement="bottom"
        title={`Finanzamt ${taxOffice.name} (${taxOfficeNumber})`}
        overlayInnerStyle={{ padding: token.paddingMD }}
        content={
          <div>
            <div>
              {taxOffice.address.street} {taxOffice.address.streetNumber}
              <br />
              {taxOffice.address.zipCode} {taxOffice.address.city}
            </div>
            {taxOffice.contact.phone && (
              <>
                <br />
                Telefon: {taxOffice.contact.phone}
              </>
            )}
            {taxOffice.contact.email && (
              <>
                <br />
                E-Mail:{' '}
                <a href={`mailto:${taxOffice.contact.email}`}>
                  {taxOffice.contact.email}
                </a>
              </>
            )}
            {taxOffice.contact.fax && (
              <>
                <br />
                Fax: {taxOffice.contact.fax}
              </>
            )}
            {taxOffice.contact.website && (
              <>
                <br />
                Website:{' '}
                <a
                  target="_blank"
                  rel="external noreferrer"
                  href={taxOffice.contact.website}
                >
                  {taxOffice.contact.website}
                </a>
              </>
            )}
          </div>
        }
      >
        <Space
          align="start"
          style={{
            fontSize: token.fontSizeSM,
            fontWeight: 500,
            color: token.colorTextSecondary,
          }}
        >
          <InfoCircleOutlined />
          <span>
            Finanzamt {taxOffice.name} ({taxOfficeNumber})
          </span>
        </Space>
      </Popover>
    </span>
  )
}
